import gql from "graphql-tag";

export const GetShippingProfiles = gql`
  query GetShippingProfiles {
    accounts {
      id
      shippingProfiles {
        id
        name
        products {
          id
        }
      }
    }
  }
`;

export const GetOwnedProducts = gql`
  query GetOwnedProducts(
    $name: QueryableString
    $price: QueryableFloat
    $createdAt: QueryableDateTime
    $limit: Int
    $cursor: String
  ) {
    stores {
      ownedProducts(
        name: $name
        price: $price
        createdAt: $createdAt
        limit: $limit
        cursor: $cursor
      ) {
        id
        name
        createdAt

        images {
          id
          url
        }
        variants {
          id
          name
          createdAt
          shippingProfile {
            id
          }
          selectedValues {
            id
            name
          }
        }
        shippingProfile {
          id
        }
      }
    }
  }
`;

export const GetShippingDetail = gql`
  query GetShippingDetail($id: String!) {
    shippingProfile(id: $id) {
      name
      id
      products {
        id
        name
        parent {
          id
          name
          images {
            url
          }
          variants {
            id
          }
        }
        images {
          url
        }
      }
      shippingZones {
        id
        name
        isRestOfWorld
        states {
          id
        }
        shippingRules {
          id
          condition
          rate
          min
          max
        }
      }
    }
  }
`;

export const GetStatesList = gql`
  query GetStatesList {
    regions {
      id
      name
      countries {
        id
        name
        states {
          id
          name
        }
      }
    }
  }
`;

export const GetShippingZoneDetail = gql`
  query GetShippingZoneDetail($id: String!) {
    shippingZone(id: $id) {
      id
      name
      isRestOfWorld
      states {
        id
      }
      shippingRules {
        id
        condition
        rate
        min
        max
      }
      shippingProfile {
        id
        name
      }
    }
  }
`;

export const GetShippingRuleDetail = gql`
  query GetShippingRuleDetail($id: String!) {
    shippingRule(id: $id) {
      id
      rate
      min
      max
      condition
    }
  }
`;
